export default {
    bgColor: 0xad3fc4,
    primaryKey: "BGElmnt_MnyBg",
    secondaryKey: "BGElmnt_Cns",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setScale(data.scaleX, data.scaleY);
        image.alpha = 0;
        let deltaY = 1 - (data.y/bg.scene.size.height);
        image.setPosition(data.x, -300);
        image.angle = -data.angle ;

        bg.scene.addTween(image, 1300, {y: data.y, angle: data.angle, delay: deltaY * 500}, "Bounce");
        bg.scene.addTween(image, 700, {alpha: 1, delay: deltaY * 500}, Phaser.Math.Easing.Sine.In);
    },
    animateOut: (image, bg)=>{
        let deltaY = 1 - (image.y/bg.scene.size.height);
        bg.scene.addTween(image, 700, {y: 1400, alpha: 0, delay: deltaY}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnt_MnyBg",
            x: 129.40232644474693, y: 535.0591341077086,
            angle: -29,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 556.6043806459597, y: 477.91235480464627,
            angle: -24,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: 941.8240316792477, y: 242.48363252375927,
            angle: -24,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: 827.0658334364559, y: 311.039070749736,
            angle: 9,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnt_MnyBg",
            x: 696.6614775399084, y: 599.8035902851109,
            angle: 19,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 974.2635812399457, y: 536.8701161562831,
            angle: -29,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: -16.648187105556243, y: 313.7771911298839,
            angle: 7,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 260.593490904591, y: 323.93558606124606,
            angle: 14,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnt_MnyBg",
            x: 434.9077094419008, y: 308.17951425554384,
            angle: -30.00000000000017,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 486.85934909045915, y: 591.8342133051742,
            angle: -6.000000000000227,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnt_MnyBg",
            x: 973.2086375448583, y: 61.72016895459346,
            angle: -30.00000000000017,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 128.78034896671204, y: 63.06758183738121,
            angle: -28.000000000000227,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 433.7670585323599, y: 776.3474128827878,
            angle: -32.000000000000114,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 340.25939858928353, y: 564.3093980992609,
            angle: 23.999999999999773,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnt_MnyBg",
            x: 831.2614280410841, y: 552.0105596620908,
            angle: -18.000000000000227,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: 619.7274347234254, y: 346.85638859556497,
            angle: -10.000000000000227,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnt_MnyBg",
            x: 1081.294344759312, y: 329.4297782470961,
            angle: 6.999999999999773,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 697.0395000618736, y: 127.51319957761352,
            angle: 19,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnt_MnyBg",
            x: 487.2373716124242, y: 118.94614572333685,
            angle: -6,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnt_MnyBg",
            x: 339.4484098502661, y: 91.75079197465682,
            angle: 23,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnt_MnyBg",
            x: 98.45068679618859, y: 242.1362196409715,
            angle: -24,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: 98.962776884049, y: 715.8532206969378,
            angle: -24,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: 831.4504393020667, y: 78.77507919746569,
            angle: -20,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: -11.380051973765623, y: 553.4984160506864,
            angle: -20,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: -11.758074495730726, y: 79.67159450897572,
            angle: -20,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: 942.6350204182652, y: 714.4751847940867,
            angle: -22,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: 557.4153693849771, y: 6.054910242872229,
            angle: -22,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnt_MnyBg",
            x: -52.380051973765624, y: 759.1277719112989,
            angle: -22,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnt_MnyBg",
            x: 258.0264571216434, y: 797.7497360084478,
            angle: 15,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnt_MnyBg",
            x: 827.4746194777874, y: 789.9144667370645,
            angle: 8,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnt_MnyBg",
            x: 612.8856824650414, y: 823.6462513199579,
            angle: 2,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        }
    ]
}